<template>
	<div>
		<v-btn
			class="mx-4"
			fab
			dark
			x-small
			color="#2F8E94"
			elevation="0"
			title="Tampilkan lebih banyak..."
			:loading="loading"
			@click="getMoreMember(data.network_code)"
		>
			<v-icon dark>
				mdi-reload
			</v-icon>
		</v-btn>
	</div>
</template>

<script>
// import { mapActions } from 'vuex'

export default {
	components: {
	},
	data() {
		return {
			loading: false
		}
	},
	props: {
		data: { type: Object }
	},
	methods: {
		async getMoreMember(kode) {
			this.loading = await true
			await this.$emit('action', kode)

			setTimeout(() => {
				this.loading = false
			}, 1000)
		},
	},
};
</script>

<style lang="scss" scoped>
</style>